import React from "react";
import { NumberInput } from "./NumberInput";

export const RecurrenceForm = ({
  formData,
  errors,
  onFieldChange,
  onSubmit,
  isSubmitting,
  t,
}) => {
  return (
    <form method="POST" className="kt-form">
      <div className="kt-form kt-form--label-right">
        <div className="kt-portlet__body">
          <NumberInput
            id="recurrence_period"
            label="Période de détermination (en jours)"
            value={formData.recurrence_period}
            onChange={(e) => onFieldChange("recurrence_period", e.target.value)}
            errors={errors.recurrence_period}
            required
            t={t}
          />

          <NumberInput
            id="max"
            label="Nombre maximum toléré"
            value={formData.max}
            onChange={(e) => onFieldChange("max", e.target.value)}
            errors={errors.max}
            required
            t={t}
          />
        </div>

        <div className="kt-portlet__foot">
          <div className="kt-form__actions text-right">
            {!isSubmitting ? (
              <button
                type="submit"
                onClick={onSubmit}
                className="btn btn-primary"
              >
                {t("Enregistrer")}
              </button>
            ) : (
              <button
                className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                type="button"
                disabled
              >
                {t("Chargement")}...
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};
